import React, { FC, ReactElement } from "react";
import { observer } from "mobx-react-lite";

import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { TabContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { Table } from "../MoveOutTerminationTabs/MoveOut.styled";
import General from "../../stores/GeneralStore";
import { Spinner } from "../SpinnerRaw/SpinnerRaw";

interface DisputeFeesProps {
  Previous: () => void;
  onClick: () => void;
  loader: boolean;

  fees: Partial<{
    currentBalance: string;
    estimatedAmount: string;
    estimatedBillId: string;
    nocFees: string;
    otherDue: string;
    ownerAccountBalance: string;
    ownerDue: string;
    payOffBalance: string;
    paymentAmount: string;
    status: string;
    statusMessage: string;
    transactionRefId: string;
    valueAddedTax: string;
    disputeFee?: string;
    serviceCharge?: string;
    totalAmount?: string;
  }>;
}

const DisputeFees: FC<DisputeFeesProps> = ({
  Previous,
  onClick,
  fees,
  loader,
}): ReactElement => {
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  const formatCurrency = (amount: any) => {
    return new Intl.NumberFormat("en", { minimumFractionDigits: 2 }).format(
      Number(amount) || 0
    );
  };

  return (
    <>
      {loader ? (
        <Spinner />
      ) : (
        <TabContainer>
          <h2
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontSize: `${1.56 * General.accessibility.fontSize}rem`,
              fontWeight: "700",
              padding: "1rem 0rem",
              color: contrast?.contrastColor
                ? contrast?.contrastColor
                : ColorAss,
            }}
          >
            {General?.codeLabels["cm_fees_charges"]?.label ||
              "Fees and Charges"}
          </h2>

          <Table beforeLastChild={true}>
            <thead>
              <tr>
                <th
                  style={{
                    textAlign: "start",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_description"]?.label ||
                    "Description"}
                </th>
                <th
                  style={{
                    textAlign: "end",
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : ColorAss,
                  }}
                >
                  {General?.codeLabels["cm_dueamt"]?.label || "Due Amount"}{" "}
                  (AED)
                </th>
              </tr>
            </thead>
            {/* <tbody>
              <tr>
                <td style={{ textAlign: "start", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                  {General?.codeLabels["cm_dispute_fee"]?.label || "Dispute Fee"}
                </td>
                <td style={{ textAlign: "end", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                  {formatCurrency(fees?.disputeFee)}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "start", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                  {General?.codeLabels["cm_service_charge"]?.label || "Service Charge"}
                </td>
                <td style={{ textAlign: "end", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                  {formatCurrency(fees?.serviceCharge)}
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "start", fontWeight: "bold", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                  {General?.codeLabels["cm_mototalamt"]?.label || "Total amount to be paid"}
                </td>
                <td style={{ textAlign: "end", fontWeight: "bold", color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss }}>
                  {formatCurrency(fees?.totalAmount)}
                </td>
              </tr>
            </tbody> */}
            <tbody>
              <tr>
                <td
                  style={{
                    textAlign: "start",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  Tenant Service Fee Due
                </td>
                <td
                  style={{
                    textAlign: "end",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  {formatCurrency(fees?.currentBalance)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "start",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  Owner Service Fee Due (Default Fees only)
                </td>
                <td
                  style={{
                    textAlign: "end",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  {formatCurrency(fees?.ownerAccountBalance)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "start",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  Deposit paid by Tenant
                </td>
                <td
                  style={{
                    textAlign: "end",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  {formatCurrency(fees?.payOffBalance)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "start",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  NOC Charge
                </td>
                <td
                  style={{
                    textAlign: "end",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  {formatCurrency(fees?.nocFees)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "start",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  New Charge as of Move Out Date
                </td>
                <td
                  style={{
                    textAlign: "end",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  {formatCurrency(fees?.estimatedAmount)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "start",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  VAT Charges
                </td>
                <td
                  style={{
                    textAlign: "end",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  {formatCurrency(fees?.valueAddedTax)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "start",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  Owner Account Due
                </td>
                <td
                  style={{
                    textAlign: "end",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  {formatCurrency(fees?.ownerDue)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "start",
                    fontWeight: "bold",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  Total
                </td>
                <td
                  style={{
                    textAlign: "end",
                    fontWeight: "bold",
                    color: contrast?.contrastColor ?? ColorAss,
                  }}
                >
                  {formatCurrency(fees?.paymentAmount)}
                </td>
              </tr>
            </tbody>
          </Table>

          <br />
          <div
            style={{
              display: "flex",
              flexDirection: General?.isLargeScreen ? "row" : "column",
              gap: "2rem",
              marginTop: "1rem",
            }}
          >
            <ButtonSecondary
              style={{
                width: General?.isLargeScreen ? "168px" : "98%",
                height: "50px",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : ColorAss,
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "#fff",
                border: `1px solid ${
                  contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : ColorAss
                }`,
              }}
              onClick={Previous}
            >
              {General?.codeLabels["cm_back"]?.label || "BACK"}
            </ButtonSecondary>
            <ButtonSecondary
              style={{
                width: General?.isLargeScreen ? "168px" : "98%",
                height: "50px",
                fontSize: `${General.accessibility.fontSize}rem`,
                color: "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : "#101E8E",
              }}
              onClick={onClick}
            >
              {General?.codeLabels["cm_btncontinue"]?.label || "Continue"}
            </ButtonSecondary>
          </div>
        </TabContainer>
      )}
    </>
  );
};

export default observer(DisputeFees);
